import axios from "axios";

const getStats = (date, mawbID) => {
  return axios
    .get(`/dashboard?date=${date}&mawbID=${mawbID ? mawbID : ''}`)
    .then(response => response)
    .catch(error => {
      throw error
    })
}

const getDataVolume = (customerID='', startDate, endDate) => {
  return axios
    .get(`/dashboard/charts/volume?customerID=${customerID}&start=${startDate}&end=${endDate}`)
    .then(response => response)
    .catch(error => {
      throw error
    })
}

export {
  getStats,
  getDataVolume,
}
